import {
  ACCOUNTKEY_AGENT_LIST_REQ,
  ACCOUNTKEY_AGENT_LIST_SUCCESS,
  ACCOUNTKEY_AGENT_LIST_ERROR,
  ACCOUNTKEY_AGENT_LIST_RESET_STATUS
} from './agents.type'

import { hostsDetailMetaInfo } from '@/column-header/hosts/hosts-details-meta'
import IQCollection from '@/resources/collections/IQCollection'
import Agent from '@/resources/models/Agent'
import ApiRest from '@/api/api-rest'
import { OrderByEnum } from '@/constants/orderby.constants'
import { AgentStateEnum } from '@/constants/host-status.constants'
import _ from 'lodash'

const state = {
  accountKeyAgentListReqStatus: '',
  accountKeyAgentList: {},
  accountKeyActiveAgentList: {}, // all active agents (excludes decommissioned agents)
  accountKeyActiveAgentSummary: {
    assetCount: 0,
    protectedCount: 0,
    unprotectedCount: 0,
    needsAttentionCount: 0,
    progressionCount: 0,
    exposedAgents: []
  }
}

const getters = {
  accountKeyAgentListReqStatus: state => state.accountKeyAgentListReqStatus,
  accountKeyAgentList: state => state.accountKeyAgentList,
  accountKeyActiveAgentList: state => state.accountKeyActiveAgentList,
  accountKeyActiveAgentSummary: state => state.accountKeyActiveAgentSummary
}

// Best Practice - updates state
const mutations = {
  [ACCOUNTKEY_AGENT_LIST_REQ]: state => {
    state.accountKeyAgentListReqStatus = 'loading'
  },
  [ACCOUNTKEY_AGENT_LIST_SUCCESS]: (state, data) => {
    state.accountKeyAgentListReqStatus = 'saved'
    state.accountKeyAgentList = data.allAgents
    state.accountKeyActiveAgentList = data.activeAgents

    state.accountKeyActiveAgentSummary.assetCount = data.activeAgents.models.length
    state.accountKeyActiveAgentSummary.protectedCount = _.filter(data.activeAgents.models, { managed: true }).length
    state.accountKeyActiveAgentSummary.unprotectedCount = _.filter(data.activeAgents.models, { managed: false }).length
    state.accountKeyActiveAgentSummary.needsAttentionCount = _.filter(data.activeAgents.models, {
      needsAttention: true
    }).length
    state.accountKeyActiveAgentSummary.progressionCount = _.sum(_.map(data.activeAgents.models, 'numProgressions'))
    state.accountKeyActiveAgentSummary.upgradeableCount = _.filter(data.activeAgents.models, 'upgradeable').length

    // openPortRanges: [{from: 3389, protocol: "tcp", to: 3389}]
    state.accountKeyActiveAgentSummary.exposedAgents = _.filter(data.activeAgents.models, agent => {
      return agent.agentDetails.openToPublicInternet === true
    })
  },
  [ACCOUNTKEY_AGENT_LIST_ERROR]: (state, errMsg) => {
    state.accountKeyAgentListReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [ACCOUNTKEY_AGENT_LIST_REQ] (context, { accountKeys }) {
    return new Promise((resolve, reject) => {
      context.commit(ACCOUNTKEY_AGENT_LIST_REQ)
      ApiRest()
        .post('/assets/vms', { keys: accountKeys })
        .then(({ data }) => {
          let iqhubVersion = context.rootState.version.iqhubVersion
          let sortKey = 'numProgressions'
          data = _.chain(data)
            .map(agent => {
              return new Agent('agentId', _.merge(agent, { iqhubVersion: iqhubVersion }))
            })
            .sort((a, b) => {
              return b[sortKey] - a[sortKey]
            })
            .value()

          let allAgents = new IQCollection(
            data,
            { attributes: hostsDetailMetaInfo.meta.columns },
            { defaultSort: sortKey, sortOrder: OrderByEnum.DESC }
          )

          let activeAgents = new IQCollection(
            _.filter(data, agent => {
              return agent.state !== AgentStateEnum.DECOMMISSIONED
            }),
            { attributes: hostsDetailMetaInfo.meta.columns },
            { defaultSort: sortKey, sortOrder: OrderByEnum.DESC }
          )

          context.commit(ACCOUNTKEY_AGENT_LIST_SUCCESS, {
            allAgents: allAgents,
            activeAgents: activeAgents
          })
          resolve(activeAgents)
        })
        .catch(errMsg => {
          context.commit(ACCOUNTKEY_AGENT_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [ACCOUNTKEY_AGENT_LIST_RESET_STATUS] (context) {
    context.commit(ACCOUNTKEY_AGENT_LIST_RESET_STATUS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/agents/accountkey-agents.module.js